import React, { useState } from "react";
import {
  Upload,
  Button,
  message,
  notification,
  Modal,
  Form,
  Row,
  Col,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
 import ImgCrop from "antd-img-crop";
import Idame from "../ReportFormGenerator/Idame/Idame";
import CropDown from "../ReportFormGenerator/CropDown/CropDown";
import But from "../ReportFormGenerator/Button/Button";
import liracrypt from "../Liracrypt/liracrypt";
import SessionError from "../ApiErrorComp/SessionError";
import ApiErrorComp from "../ApiErrorComp/ApiErrorComp";
import { ExclamationCircleOutlined, LoadingOutlined } from "@ant-design/icons";
import UniDropAdv from "../ReportFormGenerator/UniDrop/UniDropAdv";
import { useSelector } from "react-redux";

const openNotificationWithIcon = (type, message) => {
  notification[type]({
    message: message,
  });
};

const { confirm } = Modal;

const Uploader = () => {
  const urlCode = useSelector(state => state.urlCode);
  const [fileList, updateFileList] = useState([]);
  const [form] = Form.useForm();
  const [headerData, setHeaderData] = useState(null);
  const [mdictType, setMdictType] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const [loginError, setLoginError] = useState(false);
  const [reqMethod, setReqMethod] = useState("POST");

  const [loading, setLoading] = useState(false);

  const [isModalVisible, setIsModalVisible] = useState(null);
  const [modalLoading, setModalLoading] = useState(true);
  const [IMG, setIMG] = useState(null);
  const [noImg, setNoImg] = useState(false);

  const uplBtnRef = React.useRef();

  const props = {
    fileList,
    method: "POST",
    action: `${process.env.REACT_APP_API_ENDPOINT
      }/imageupload?token=${localStorage.getItem("token")}&urlCode=${urlCode}`,
    beforeUpload: (file) => {
      
      if (
        file.type == "image/png" ||
        file.type == "image/jpeg" ||
        file.type == "image/jpg"
      ) {
        return file.type === "image/png" || file.type === "image/jpeg";
      } else {
        message.error(`${file.name} is not a png/jpg file`);
      }
    },
    onChange: (info) => {
      
      if (info.file.status == "done") {
        openNotificationWithIcon(
          "success",
          `Uploaded ${info.file.name} Successfully`
        );
      }
      if (info.file.status == "error") {
        openNotificationWithIcon(
          "error",
          `Uploaded ${info.file.name} Failed !`
        );
      }
      // updateFileList(info.fileList.filter((file) => !!file.status));
    },
  };

  const onFinish = (values) => {
    setLoading(true);
    setHeaderData(values);

    // values["_id"] = values["subTyp"];
    const imageId = values["typ"] + "_" + values["subTyp"];

    values["_id"] = imageId;

    

    // showConfirm();
    liracrypt
      .get("/misc/image/single", values)
      .then((res, req) => {
        if (res.status === 204) {
          setReqMethod("POST");
          uplBtnRef.current.click();
        } else if (res.status === 200) {
          showConfirm(values);
        }
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error****:");
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });

    // uplBtnRef.current.click();
  };

  const onChangeMdict = (value) => {
    setMdictType(value);
    form.resetFields(['subTyp', 'subTypName']);
  };

  function showConfirm(values) {
    confirm({
      title: "Image Already Exist !",
      icon: <ExclamationCircleOutlined />,
      okText: <span style={{ fontWeight: 600 }}>Replace</span>,
      cancelText: <span style={{ fontWeight: 600 }}>Cancel</span>,
      cancelButtonProps: { ghost: true, danger: true },
      okButtonProps: { ghost: true },
      onOk() {
        
        setReqMethod("PUT");
        setHeaderData({ typ: values["typ"], subTyp: values["subTyp"] });
        // setHeaderData({ _id: values["subTyp"] });
        uplBtnRef.current.click();
      },
      onCancel() {
        
      },
    });
  }

  const IdameRef = () => {
    return (
      <>
        {mdictType ? (
          <Idame
            // width = {100}
            form={form}
            type="name"
            url="/mdict"
            urlData={{
              typ: mdictType,
              subTyp: "ijoint",
              includeAll: false,
            }}
            idName="subTyp"
            idLabel="SubType"
            idErrorMessage={`Please Select ${mdictType}`}
            idRequired={true}
            idPlaceholder={`Select ${mdictType}`}
            nameName="subTypName"
            nameLabel="SubType"
            nameErrorMessage={`Please Select ${mdictType}`}
            nameRequired={true}
            namePlaceholder={`Select ${mdictType}`}
          />
        ) : (
          <></>
        )}
      </>
    );
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onViewImg = () => {
    setIMG(null);
    setNoImg(false);
    if (form.getFieldValue("subTyp")) {
      setIsModalVisible(true);
      liracrypt
        .get("/imagecontrol", {
          _id: form.getFieldValue("typ") + "_" + form.getFieldValue("subTyp"),
          typ: form.getFieldValue("typ"),
        })
        .then((res, req) => {
          if (res.status === 200) {
            setIMG(res.data.data);
            setModalLoading(false);
          } else if (res.status === 204) {
            setNoImg(true);
          }
        })
        .catch((error) => {
          setIsModalVisible(false);
          console.log("Error****:");
          if (error.response !== undefined) {
            if (error.response.status !== 401) {
              ApiErrorComp(error.response.status);
            } else {
              setLoginError(true);
            }
          }
        });
    } else {
      form.submit();
    }
  };

  const ImgDiv = () => {
    return (
      <>
        {noImg ? (
          <>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
                color: "#fff",
                fontWeight: 600,
              }}
            >
              No Image Available
            </div>
          </>
        ) : (
          <div style={{ textAlign: "center" }}>
            <img src={IMG} width="320px" height="250px" />
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <SessionError visible={loginError} />

      <Modal
        title="View Image"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        cancelButtonProps={{ hidden: true }}
        okText={<span style={{ fontWeight: 600 }}>OK</span>}
      >
        {modalLoading ? (
          <>
            <div
              style={{
                flex: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                style={{
                  minHeight: "250px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <LoadingOutlined
                  style={{ fontSize: 60, color: "#dc3545" }}
                  spin
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <ImgDiv />
          </>
        )}
      </Modal>

      {/* <StablePrime url="/misc/image/multi" data={{}} identity="Images" /> */}
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row justify="center">
              <Col span={12}>


                <UniDropAdv
                  form={form}
                  colSpan={36}
                  multiSelect={false}
                  url={"/cropdown"}
                  disabled={false}
                  source={"cropdown"}
                  urlData={{ name: "ImageUpload" }}
                  pname={"typ"}
                  name={"typ1"}
                  label={"Type"}
                  errorMessage={"Please Select Type !"}
                  required={true}
                  placeholder={"Select Type"}
                  defaultValue={null}
                  searchable={true}
                  includeAll={false}
                  onChange={onChangeMdict}
                />












                {/* 
              <DropDown
                  form={form}
                  name="typ"
                  label="Type"
                  required={true}
                  errorMessage="Please Select Type"
                  placeholder="Select Type"
                  searchable={true}
                  defaultValue=""
                  options={[
                    
                    { label: "Employees", value: "Employees" },
                    { label: "Part", value: "Part" },
                    { label: "Customer", value: "Customer" },
                  ]}
                  onChange={onChange}
                /> */}

                {/* <CropDown
                  form={form}
                  name="typ"
                  // defaultValue={{ label: "Line", value: "Line" }}
                  label="Type"
                  placeholder="Select Type"
                  url="/cropdown"
                  urlData={{ name: "imageUpload" }}
                  required={true}
                  errorMessage="Please Select Type"
                  onChange={onChange}
                /> */}
              </Col>
            </Row>
            <Row justify="center">
              <Col span={12}>
                <IdameRef />
              </Col>
            </Row>
            <Row gutter={24} justify="center">
              <Col span={24}>
                <But
                  form={form}
                  submitButtonText={"Upload Image"}
                  loading={loading}
                  resetButton={true}
                >
                  <Button
                    style={{
                      marginLeft: "20px",
                      fontWeight: 600,
                      borderRadius: "10px",
                    }}
                    type="danger"
                    onClick={onViewImg}
                  >
                    View Image
                  </Button>
                </But>

                <ImgCrop aspect={1.28}>
                  <Upload {...props} headers={headerData}>
                    <Button
                      // type="primary"
                      // htmlType="submit"
                      ref={uplBtnRef}
                      style={{ fontWeight: 600, visibility: "hidden" }}
                      type="danger"
                      icon={<UploadOutlined />}
                    >
                      Upload Image
                    </Button>
                  </Upload>
                </ImgCrop>
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
};

export default Uploader;
